import Image from 'next/image';
import { cn } from '@lib/utils';

export default function DesktopSectionEclipse({
  half,
  className,
}: {
  half: 'upper' | 'lower';
  className?: string;
}) {
  const isUpper = half === 'upper';

  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-x-0 hidden aspect-[1920/280] overflow-hidden xl:block',
        isUpper ? 'bottom-0' : 'top-0',
        className,
      )}
    >
      {/* 제공된 2배율 PNG(2195×280)를 원본 비율로 표시한다. */}
      <Image
        src={
          isUpper
            ? '/images/main/reanalysis/eclipse-desktop-upper.png'
            : '/images/main/reanalysis/eclipse-desktop-lower.png'
        }
        alt=""
        width={4390}
        height={560}
        sizes="115vw"
        className="absolute left-1/2 top-0 h-auto w-[114.322917%] max-w-none -translate-x-1/2"
      />
    </div>
  );
}
